import {Directive, inject, Input} from '@angular/core';
import {RouteNameCapableButtonComponent} from '@aviary/buttons/button.types';
import {ROUTE_NAME_CAPABLE_BUTTON_COMPONENT} from '@aviary/injection-tokens/aviary-only.tokens';

/** For Aviary-owned templates. Application templates use their app-specific, strongly typed [routeName] directive instead. */
@Directive({
  selector: 'mx-filled-button[aviaryRouteName], mx-outlined-button[aviaryRouteName], mx-text-button[aviaryRouteName],' +
    ' mx-elevated-button[aviaryRouteName], mx-icon-button[aviaryRouteName], mx-fab[aviaryRouteName], mx-link-button[aviaryRouteName]'
})
export class AviaryButtonRouteNameDirective {

  @Input() public set aviaryRouteName(routeName: string | undefined) {
    this.buttonComponent.genericRouteName = routeName;
  }

  private readonly buttonComponent: RouteNameCapableButtonComponent = inject(ROUTE_NAME_CAPABLE_BUTTON_COMPONENT);
}
